import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import { noop } from '../../../../lib/utilities';
import { ProductSetPrice } from './rows/product_set_price';
import { ProductSetPriceBuy4Pay3 } from './rows/product_b4p3_set_price';
import { ServiceFittingStation } from './rows/service_fitting_station';
import { ShippingPrice } from './rows/shipping_price';
import { TotalPrice } from './rows/total_price';
import { AddToCart } from './rows/add_to_cart';
import { AddServiceFittingStation } from './rows/add_service_fitting_station';
import { ServiceFittingStationNotAvailable } from './rows/service_fitting_station_not_available';
import { OptionSeparator } from './rows/option_separator';
import { Sale } from './rows/sale';
import { FreeFitting } from './rows/free_fitting';
import { featureFlags } from '../../../_constants/feature_flags';
import { ProductSingleItemPrice } from './rows/product_single_item_price';
import { ProductQuantityRow } from './rows/product_quantity_row';
// TODO: Temporary disabled matesrates
// import { ProductSingleItemPriceMatesRates } from './rows/product_single_item_price_mates_rates';
// import { ProductSetPriceMatesRates } from './rows/product_set_price_mates_rates';
import { ShowQuantityAndPrice } from './rows/show_quantity_and_price';
import { Table } from './structure/table';
import { ProductDiscount } from './rows/product/sca_25_percent_discount';
import { SetPriceRow } from './rows/product/set_price_row';
import { CrossSellProducts } from './rows/cross_sell_products';
import { CrossSellProductStore } from '../../stores/cross_sell_product_store';
import { updateAction } from '../../actions/cross_sell_products_actions';

export function Pdp(props) {
  const finalItemPrice = props.isMpsProduct ? props.mpsProductStock.frontendPrice : props.price;

  const onChangeCrossSellCheckbox = (value, idString) => {
    const id = idString.substring(28);
    CrossSellProductStore.getState().forEach((csp, idx) => {
      if (csp.spinachId === id) {
        csp.preselected = value;
        updateAction({ spinachId: csp.spinachId, preselected: value });
      }
    });
  };

  const rows = [
    shouldDisplayPromotion(props) && getPromotionRow(props),

    shouldDisplaySaleRow(props) && getSaleRow(props),

    // !props.quantityAndPriceRowVisible && getShowQuantityAndPriceRow(props),
    // props.quantityAndPriceRowVisible && getProductQuantityRow(props),
    // props.quantityAndPriceRowVisible && getProductSingleItemPriceRow(props),

    getProductQuantityRow(props),
    getProductSingleItemPriceRow(props),

    // props.quantityAndPriceRowVisible && shouldDisplayMatesRates(props)
    // && getProductSingleItemPriceRowMatesRates(props),

    props.quantity > 1 && getProductSetPriceRow(props, finalItemPrice),
    // props.quantity >= 4 && featureFlags.FEATURE_TYRE_DEALS && props.buy4pay3 && <ProductSetPrice
    //   buy4pay3={props.buy4pay3}
    //   pricePerItem={props.isMpsProduct ? props.mpsProductStock.frontendPrice : props.price}
    //   isMpsProduct={props.isMpsProduct}
    //   quantity={props.quantity}
    //   setPrice={(props.quantity * props.price) - (Math.floor(props.quantity / 4) * props.price)}
    //   cashback100={props.cashback100}
    //   currencyIsoCode={props.currencyIsoCode}
    //   hideLabel={true}
    //   key="ProductSetPriceDiscountB4P3"
    // />,

    // props.getCalculatedDiscountAmount(props.priceDiscount, props.quantity, finalItemPrice) > 0 && <SetPriceRow
    //   quantity={props.quantity}
    //   pricePerItem={finalItemPrice}
    //   isMpsProduct={props.isMpsProduct}
    //   currencyIsoCode={props.currencyIsoCode}
    //   hasPaddingBottom
    //   hasDiscount
    //   hideLabel
    //   discountPrice={props.getCalculatedDiscountAmount(props.priceDiscount, props.quantity, finalItemPrice)}
    //   key="ProductSetPriceRowDiscount"
    // />,

    featureFlags.FEATURE_SCA_25_PERCENT_DISCOUNT && (
      <ProductDiscount
        discountName="25% Australia Day Promo"
        discountAmount={Math.floor(finalItemPrice * 0.25) * props.quantity}
        currencyIsoCode={props.currencyIsoCode}
      />
    ),

    props.quantity >= 4 && getProductSetPriceBuy4Pay3Row(props),

    // props.getCalculatedDiscountAmount(props.priceDiscount, props.quantity, finalItemPrice) > 0 && (
    (
      <ProductDiscount
        discountName={props.priceDiscount && props.priceDiscount.text || ''}
        discountAmount={props.getCalculatedDiscountAmount(props.priceDiscount, props.quantity, finalItemPrice) || ''}
        currencyIsoCode={props.currencyIsoCode}
        type="price"
      />
    ),

    // props.quantity > 1 && shouldDisplayMatesRates(props)
    //     && getProductSetPriceRowMatesRates(props),
    props.crossSellProducts && props.crossSellProducts[0] && getCrossSellProducts(props, onChangeCrossSellCheckbox),

    props.hasFitting && getServiceFittingStationRow(props),

    props.hasFitting && props.shippingPrice !== -1 && getShippingPriceRow(props),

    props.hasFitting && getTotalPriceRow(props),

    props.fittingNotAvailable && getServiceFittingStationNotAvailableRow(props),

    !props.fittingNotAvailable && !props.hasFitting && getAddServiceFittingStationRow(props),

    // shouldDisplayMatesRates(props) && props.hasFitting
    //     && getTotalPriceMatesRatesRow(props, getMatesRatesLearnMore(props)),

    // !props.hasFitting && <OptionSeparator key="AboveAddToCartSeparator" />,

    getAddToCartRow(props),
  ];

  return (
    <React.Fragment>
      <Table rows={rows} key="Sidebar" hasFitting={props.hasFitting} />
    </React.Fragment>
  );
}

Pdp.propTypes = {
  crossSellProducts: PropTypes.object,
  availableQuantities: PropTypes.arrayOf(PropTypes.number).isRequired,
  quantity: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  setPrice: PropTypes.number.isRequired,
  onChangeStationClick: PropTypes.func.isRequired,
  onRemoveStationClick: PropTypes.func.isRequired,
  fittingPrice: PropTypes.number.isRequired,
  wheelAlignmentQuantity: PropTypes.number.isRequired,
  wheelAlignmentPrice: PropTypes.number.isRequired,
  fittingNotAvailable: PropTypes.bool.isRequired,
  isMobileFitter: PropTypes.bool.isRequired,
  calloutFeePrice: PropTypes.number.isRequired,
  hasFitting: PropTypes.bool.isRequired,
  hasWheelAlignment: PropTypes.bool,
  hasShipping: PropTypes.bool.isRequired,
  hasAccessories: PropTypes.bool,
  hasWheels: PropTypes.bool,
  hasTools: PropTypes.bool,
  shippingPrice: PropTypes.number.isRequired,
  shippingTime: PropTypes.string.isRequired,
  totalPrice: PropTypes.number.isRequired,
  totalPriceMatesRates: PropTypes.number.isRequired,
  buy4pay3: PropTypes.bool.isRequired,
  cashback100: PropTypes.bool.isRequired,
  clearance: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  quantityAndPriceRowVisible: PropTypes.bool.isRequired,
  tyreId: PropTypes.string.isRequired,
  fittingStationId: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  onMatesRatesLearnMoreClick: PropTypes.func.isRequired,
  onMoreInfoWheelAlignmentClick: PropTypes.func.isRequired,
  onAddServiceFittingStationClick: PropTypes.func.isRequired,
  onAddFittingServiceLearnMoreClick: PropTypes.func.isRequired,
  onFittingNotAvailableLearnMoreClick: PropTypes.func.isRequired,
  onShowQuantityAndPriceClick: PropTypes.func.isRequired,
  salePrice: PropTypes.number,
  onAddToCartClick: PropTypes.func,
  fittingStationStreet: PropTypes.string,
  fittingStationSuburb: PropTypes.string,
  sidebarPostcode: PropTypes.string,
  isMpsProduct: PropTypes.bool,
  mpsProductStock: PropTypes.object,
  fittingPromotion: PropTypes.object,
};

Pdp.defaultProps = {
  salePrice: 0,
  onAddToCartClick: noop,
  fittingStationStreet: '',
  fittingStationSuburb: '',
  sidebarPostcode: '',
  isMpsProduct: false,
  mpsProductStock: null,
  crossSellProducts: null,
};

const getMatesRatesLearnMore = (props) => (
  <Translation
    translationKey="product-tile-frienbuy-price-learn-more"
    className="product-set-price__learn-more"
    onClick={props.onMatesRatesLearnMoreClick}
    key="MatesRatesLearnMore"
  />
);

const _isPriceDiscountApplied = (discount) =>
  (discount && Object.prototype.hasOwnProperty.call(discount, 'discountValue') && discount.discountValue > 0) || false;

const shouldDisplaySaleRow = (props) =>
  (featureFlags.FEATURE_PRICE_RRP && props.salePrice) || (featureFlags.FEATURE_TYRE_DEALS && props.clearance);

const shouldDisplayPromotion = ({ fittingPromotion }) =>
  fittingPromotion &&
  Object.prototype.hasOwnProperty.call(fittingPromotion, 'promotionName') &&
  (fittingPromotion.promotionName === 'free_fitting' || fittingPromotion.promotionName === 'free_mobile_fitting');

const shouldDisplayMatesRates = (props) =>
  (featureFlags.FEATURE_FRIEND_BUY && featureFlags.FEATURE_TYRE_DEALS && false === props.buy4pay3) ||
  (featureFlags.FEATURE_FRIEND_BUY && !featureFlags.FEATURE_TYRE_DEALS) ||
  (featureFlags.FEATURE_FRIEND_BUY && props.quantity < 4);

const getSaleRow = (props) => (
  <Sale salePrice={props.salePrice} currencyIsoCode={props.currencyIsoCode} clearance={props.clearance} key="Sale" />
);

const getPromotionRow = (props) => <FreeFitting fittingPromotion={props.fittingPromotion} key="fittingPromotion" />;

const getShowQuantityAndPriceRow = (props) => (
  <ShowQuantityAndPrice onShowClick={props.onShowQuantityAndPriceClick} key="ShowQuantityAndPrice" />
);

const getProductQuantityRow = (props) => (
  <ProductQuantityRow
    availableQuantities={props.availableQuantities}
    quantity={props.quantity}
    onQuantityChange={props.onQuantityChange}
    key="ProductQuantityRow"
  />
);

const getProductSingleItemPriceRow = (props) => (
  <ProductSingleItemPrice
    price={props.isMpsProduct ? props.mpsProductStock.frontendPrice : props.price}
    isMpsProduct={props.isMpsProduct}
    currencyIsoCode={props.currencyIsoCode}
    key="ProductSingleItemPrices"
  />
);

// const getProductSingleItemPriceRowMatesRates = props => (
//     <ProductSingleItemPriceMatesRates
//         price={props.isMpsProduct ? props.mpsProductStock.frontendPrice : props.price}
//         currencyIsoCode={props.currencyIsoCode}
//         onMatesRatesLearnMoreClick={props.onMatesRatesLearnMoreClick}
//         key="ProductSingleItemPricesMatesRates"
//     />
// );

const getProductSetPriceRow = (props, finalItemPrice) => (
  <ProductSetPrice
    buy4pay3={props.buy4pay3}
    pricePerItem={props.isMpsProduct ? props.mpsProductStock.frontendPrice : props.price}
    isMpsProduct={props.isMpsProduct}
    quantity={props.quantity}
    setPrice={props.setPrice}
    cashback100={props.cashback100}
    currencyIsoCode={props.currencyIsoCode}
    className={`${
      (props.quantity >= 4 && props.buy4pay3) ||
      props.getCalculatedDiscountAmount(props.priceDiscount, props.quantity, finalItemPrice) > 0
        ? 'no-text-decoration-line-through'
        : ''
    }`}
    // noBottomPadding={((props.quantity >= 4 && props.buy4pay3) || props.getCalculatedDiscountAmount(props.priceDiscount, props.quantity, finalItemPrice) > 0)}
    key="ProductSetPrice"
  />
);

const getProductSetPriceBuy4Pay3Row = (props) => (
  <ProductSetPriceBuy4Pay3
    pricePerItem={props.isMpsProduct ? props.mpsProductStock.frontendPrice : props.price}
    quantity={props.quantity}
    setPrice={props.setPrice}
    buy4pay3={props.buy4pay3}
    currencyIsoCode={props.currencyIsoCode}
    key="ProductSetPriceBuy4Pay3"
  />
);

// const getProductSetPriceRowMatesRates = props => (
//     <ProductSetPriceMatesRates
//         pricePerItem={props.isMpsProduct ? props.mpsProductStock.frontendPrice : props.price}
//         quantity={props.quantity}
//         currencyIsoCode={props.currencyIsoCode}
//         onMatesRatesLearnMoreClick={props.onMatesRatesLearnMoreClick}
//         key="ProductSetPriceMatesRates"
//     />
// );

const getServiceFittingStationNotAvailableRow = (props) => (
  <ServiceFittingStationNotAvailable
    onLearnMoreClick={props.onFittingNotAvailableLearnMoreClick}
    key="ServiceFittingStationNotAvailable"
  />
);

const getCrossSellProducts = (props, onChangeCrossSellCheckbox) => {
  const csProducts = Object.keys(props.crossSellProducts).map((csp) => (
    <CrossSellProducts
      crossSellProd={props.crossSellProducts[csp]}
      currencyIsoCode={props.currencyIsoCode}
      loading={props.loading}
      onRemoveClick={props.onRemoveCrossSellClick}
      onDetailsClick={props.onCrossSellClick}
      onChangeCrossSellCheckbox={onChangeCrossSellCheckbox}
      key={`CrossSellProducts-${props.crossSellProducts[csp].spinachId}`}
    />
  ));

  return <>{csProducts}</>;
};

const getServiceFittingStationRow = (props) => {
  const fsTotalPrice = props.fittingPrice + props.wheelAlignmentPrice + props.calloutFeePrice;

  return (
    <ServiceFittingStation
      quantity={props.quantity}
      hasFitting={props.hasFitting}
      hasWheelAlignment={props.hasWheelAlignment}
      fittingPrice={props.fittingPrice}
      fsTotalPrice={fsTotalPrice}
      isMobileFitter={props.isMobileFitter}
      fsDetailsVisible={true}
      calloutFeePrice={props.calloutFeePrice}
      fittingStationStreet={props.fittingStationStreet}
      fittingStationSuburb={props.fittingStationSuburb}
      sidebarPostcode={props.sidebarPostcode}
      wheelAlignmentQuantity={props.wheelAlignmentQuantity}
      wheelAlignmentPrice={props.wheelAlignmentPrice}
      onMoreInfoWheelAlignmentClick={props.onMoreInfoWheelAlignmentClick}
      onChangeStationClick={props.onChangeStationClick}
      onRemoveStationClick={props.onRemoveStationClick}
      currencyIsoCode={props.currencyIsoCode}
      loading={props.loading}
      key="ServiceFittingStation"
    />
  );
};

const getAddServiceFittingStationRow = (props) => (
  <AddServiceFittingStation
    onLearnMoreClick={props.onAddFittingServiceLearnMoreClick}
    onAddServiceFittingStationClick={props.onAddServiceFittingStationClick}
    key="AddServiceFittingStation"
  />
);

const getShippingPriceRow = (props) => (
  <ShippingPrice
    hasAccessories={props.hasAccessories}
    hasWheels={props.hasWheels}
    hasTools={props.hasTools}
    shippingPrice={props.shippingPrice}
    shippingTime={props.shippingTime}
    sidebarPostcode={props.sidebarPostcode}
    isMobileFitter={props.isMobileFitter}
    currencyIsoCode={props.currencyIsoCode}
    loading={props.loading}
    onCalculateClick={props.onCalculate}
    key="ShippingPrice"
  />
);

const getTotalPriceRow = (props) => (
  <TotalPrice
    totalPrice={props.totalPrice}
    currencyIsoCode={props.currencyIsoCode}
    loading={props.loading}
    hasFitting={props.hasFitting}
    key="TotalPrice"
  />
);

// const getTotalPriceMatesRatesRow = props => (
//     <TotalPrice
//         totalPrice={props.totalPriceMatesRates}
//         currencyIsoCode={props.currencyIsoCode}
//         loading={props.loading}
//         name="total-price total-price--mates-rates"
//         key="TotalPriceMatesRates"
//         labelKey="pdp-sidebar-total-price-mates-rates"
//         currencySetupOverrides={{ decimalDigits: 2 }}
//         onLabelClick={props.onMatesRatesLearnMoreClick}
//     />
// );

const getAddToCartRow = (props) => (
  <AddToCart
    totalPrice={props.totalPrice}
    currencyIsoCode={props.currencyIsoCode}
    hasFitting={props.hasFitting}
    fittingNotAvailable={props.fittingNotAvailable}
    onAddClick={props.onAddToCartClick}
    key="AddToCart"
    tyreId={props.tyreId}
    baseUrl={props.baseUrl}
    productQuantity={props.quantity}
    fittingStationId={props.fittingStationId}
    wheelAlignmentTwo={props.wheelAlignmentQuantity === 2}
    wheelAlignmentFour={props.wheelAlignmentQuantity === 4}
  />
);
